import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setJobDetail, setJobs } from "@store/actions/job.action";
import { getJobs, updateJob } from "@endpoints/job.service";
import { datePostedType, JobStatus, JobType } from "@utils/constants";
import { useForm } from "react-hook-form";
import { isNullOrEmpty } from "@utils/helperFunction";
import { useSnackbar } from "notistack";
import dayjs from "dayjs";
import { RootState } from "@store/reducers";
import PlusIcon from "@assets/svg/PlusIcon";
import { NavLink } from "react-router-dom";

const JobCard = ({ data, handleCloseJob }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <NavLink
      to={`/job/${data?._id}/applicants`}
      state={data}
      onClick={() => {
        dispatch(setJobDetail(data));
        // navigate(`/job/${data?._id}/applicants`, { state: data });
      }}
      className="grid grid-cols-[0.5fr_1fr_0.7fr_0.7fr] gap-16 items-center justify-between bg-white border-b border-[#ececec] rounded px-6 py-6 hover:bg-gray-50 cursor-pointer"
    >
      <div className="flex flex-col gap-1">
        <span className="text-xs text-primary font-medium bg-[#FAFAFA] py-2 px-5 text-center">
          {data?.refNo}
        </span>
        <div className="flex items-center justify-center bg-[#F1F5F9] rounded-md py-2 px-5 text-xs font-medium text-primary">
          {data?.status === JobStatus.LIVE && "Live"}
          {data?.status === JobStatus.DRAFT && "Draft"}
          {data?.status === JobStatus.UNPUBLISHED && "Unpublished"}
          {data?.status === JobStatus.CLOSED && "Closed"}
          {data?.status === JobStatus.EXPIRED && "Expired"}
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-xs text-primary font-bold py-2 px-5">
          {data.title}
        </span>
        <div className="flex items-center rounded-sm py-2 px-5 text-xs text-light-black">
          Client : {data?.companyDetails ? data?.companyDetails?.name : "N/A"}
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="flex flex-col gap-1">
          <span className="text-xs text-primary py-2">Published</span>
          <div className="py-2 text-xs text-primary">
            {data?.status === JobStatus.EXPIRED ? "Expired" : "Expiring"}
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-xs text-primary py-2">
            {dayjs(data?.createdAt).format("hh:mm A DD/MM/YY")}
          </span>
          <div className="py-2 text-xs text-primary">
            {dayjs(data?.createdAt).add(30, "days").format("hh:mm A DD/MM/YY")}
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-1 items-center">
        <div className="flex items-center justify-center rounded bg-[#F1F5F9] py-2 px-5 text-xs font-medium text-primary">
          Applicants
        </div>
        <div className="text-xs text-primary font-medium border border-primary rounded-full w-8 h-8 flex items-center justify-center relative">
          {data.totalApplicants}{" "}
          {data.unViewedApplicants > 0 && (
            <p className="h-3 w-3 bg-[#23BD33] rounded-full absolute -top-1 -right-3 flex items-center justify-center text-white text-xss">
              {data.unViewedApplicants}
            </p>
          )}
        </div>
      </div>
      {/* {activeTab === 0 && (
          <div
            className="text-white text-xs font-medium bg-red-500 py-1.5 px-1 rounded"
            onClick={(event) => {
              event.stopPropagation();
              handleCloseJob(data._id, 3);
            }}
          >
            Close Job
          </div>
        )} */}
    </NavLink>
  );
};

const ViewByJob = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasFetched = useRef(false);
  const { enqueueSnackbar } = useSnackbar();
  const {
    control,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      search: undefined,
      searchBy: "Search by",
    },
  });
  const fields = watch();
  const { jobs } = useSelector((state: RootState) => state?.job);

  const [loading, setLoading] = useState(jobs?.length === 0);

  const fetchJobs = () => {
    getJobs(
      !isNullOrEmpty(fields?.search) && {
        filter: {
          ...(fields?.searchBy === "Search by" && {
            searchText: fields.search,
          }),
          ...(fields?.searchBy === "Industry Type" && {
            industryType: fields.search,
          }),
          ...(fields?.searchBy === "Job Type" && {
            jobType: JobType.find((x) => x.label === fields.search)?.value,
          }),
          ...(fields?.searchBy === "Date Posted" && {
            datePosted: datePostedType.find((x) => x.label === fields.search)
              ?.value,
          }),
        },
      }
    )
      .then((response) => {
        const { data, success } = response;
        if (success) {
          dispatch(setJobs(data));
        }
      })
      .finally(() => setLoading(false));
  };

  const handleCloseJob = async (jobId, status) => {
    try {
      const { success } = await updateJob({ jobId, status });
      if (success) {
        fetchJobs();
        enqueueSnackbar("Job Closed Successfully!", { variant: "success" });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchJobs();
    }
  }, [fields?.search]);

  return loading ? (
    <div className="gap-2.5 flex mt-16 flex-col">
      {Array.from({ length: 10 }, (x, i) => i).map((key) => {
        return (
          <div className="flex justify-between">
            <div
              style={{
                borderWidth: 1,
              }}
              className="flex rounded-lg w-full pl-3 pr-8 py-4 gap-1.5"
            >
              <div className="h-3 rounded bg-gray-200 w-1/4"></div>
              <div className="h-3 rounded bg-gray-200 w-1/4"></div>
              <div className="h-3 rounded bg-gray-200 w-1/4"></div>
            </div>
          </div>
        );
      })}
    </div>
  ) : jobs?.length === 0 ? (
    <div className="flex flex-1 h-screen flex-col items-center justify-center">
      <p className="text-primary font-semibold">No Job created</p>
      <p className="mt-2 mb-5">Create a Job now!</p>
      <button
        onClick={() => navigate("create")}
        className="flex items-center justify-center border bg-green-600 rounded-md px-2 py-1 gap-1 text-white font-medium text-sm"
      >
        <PlusIcon className={"w-4 h-4"} fill={"white"} />
        Create Job Post
      </button>
    </div>
  ) : (
    <div className="flex flex-col mt-2 max-h-fit overflow-y-scroll no-scrollbar border-t">
      {jobs?.length ? (
        jobs?.map((job) => {
          return (
            <JobCard
              key={job?._id}
              data={job}
              handleCloseJob={handleCloseJob}
            />
          );
        })
      ) : (
        <div className="flex-grow">
          <span className="m-auto font-medium text-xs">No jobs found.</span>
        </div>
      )}
    </div>
  );
};

export default ViewByJob;
